<template>
	<div>
		<b-row>
			<b-col md="12" class="mb-4">
				<h6>Null</h6>
				<campus-selectbox v-model="value1" :public="true"/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Single Selected</h6>
				<campus-selectbox v-model="value2" :public="true"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<campus-selectbox v-model="value3" :public="true" :validateError="value3ValidateError"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change') }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import CampusSelectbox from "@/components/interactive-fields/CampusSelectbox";

	export default {
		components: {
			CampusSelectbox
		},
		data() {
			return {
				value1: null,
				value2: 8,
				value3: 8,
				value3ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value1 = null;
				this.value2 = 2;
				this.value3 = 2;
				this.value3ValidateError = 'Error'
			}
		}
	};
</script>

